import styled from 'styled-components'
import { device } from '../Breakpoints'
import { colors } from '../Colors'

const Container = styled.div`
  width: 100%;

  .center {
    margin: auto;
    display: flex;
    justify-content: space-between;
    align-items: start;
    @media ${device.mobileL} {
      max-width: 100%;
      text-align: center;
      flex-wrap: wrap;
    }
    h2 {
      text-align: left;
      margin-top: 1em;
      margin-bottom: 0.4em;

      @media ${device.mobileL} {
        text-align: center;
      }
    }
  }
  h2 {
    margin-top: 2em;
    text-align: center;
    color: ${colors.verde};
    font-size: 1.2em;
  }

  ul.list {
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    order: 1;
    @media ${device.mobileL} {
      margin: 2em;
      order: 2;
    }
    li {
      list-style: none;
      background: #fff;
      border: 1px solid #ebebea;
      margin-bottom: 0.5em;
      width: 100%;
      box-sizing: border-box;
      padding: 2em;
      justify-content: space-between;
      display: flex;
      flex-wrap: wrap;
      align-content: space-between;
      @media ${device.mobileL} {
        width: 100%;
      }
      .thumb {
        margin: -2em -2em 1.5em;
        overflow: hidden;
        max-height: 212px;
        img {
          width: 100%;
        }
      }
      small {
        font-size: 0.6em;
        padding: 0;
        color: #4a4a4a !important;
      }
      h3 {
        margin: 0 0 0.5em;
        display: block;
        width: 100%;
        font-size: 1.5em;
        a {
          color: ${colors.vermelho};
          text-decoration: none;
          display: block;
        }
      }
      p {
        font-size: 0.6em;

        color: #4a4a4a !important;
      }
    }
  }
  ul.categories {
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: space-between;
    li {
      margin: 0 0.5em 0 0;
      border: 0;
      background: red;
      padding: 0.5em 0.8em;
      border-radius: 5px;
      width: auto;
      color: #ffffff;
      font-size: 0.6em;
    }
  }
`

export default Container
